export class PredefinedFileterPropertyCodes {
    static readonly ID = 'id';
    static readonly NAME = 'name';
    static readonly ORGANIZATION_ID = 'organizationId';
    static readonly VIEW_ID = 'viewId';
    static readonly SHARED = 'shared';
    static readonly OWNER_ID = 'ownerId';
    static readonly SEARCH_TERM = 'searchTerm';
    static readonly FILTERED_ATTRIBUTES = 'filteredAttributes';
}
